import module from 'nominas/nomina/module.js'

export default class NominasNominaExportarService {
  constructor ($q, $export, NominasNominaExportarResumen, NominasNominaExportarServicios, NominasNominaExportarMovimientos, NominasNominaExportarBancos, NominasNominaExportarBancosResumen) {
    this.$q = $q
    this.$export = $export
    this.NominasNominaExportarResumen = NominasNominaExportarResumen
    this.NominasNominaExportarServicios = NominasNominaExportarServicios
    this.NominasNominaExportarMovimientos = NominasNominaExportarMovimientos
    this.NominasNominaExportarBancos = NominasNominaExportarBancos
    this.NominasNominaExportarBancosResumen = NominasNominaExportarBancosResumen
  }

  excel (idProyecto, idNomina, opciones = {}) {
    let paginas = []

    if (opciones.incluir_resumen) {
      paginas.push(this.NominasNominaExportarResumen.get(idProyecto, idNomina, opciones))
    }

    if (opciones.pueblo_bonito) {
      paginas.push(this.NominasNominaExportarServicios.get(idProyecto, idNomina, opciones.logotipo, opciones.separar_salas, opciones.omitir_conceptos_cero, opciones.incluir_departamentos))
    } else {
      paginas.push(this.NominasNominaExportarMovimientos.get(idProyecto, idNomina, opciones.logotipo, opciones.separar_salas, opciones.omitir_conceptos_cero, opciones.incluir_departamentos))
    }

    if (opciones.incluir_bancos) {
      paginas.push(this.NominasNominaExportarBancos.get(idProyecto, idNomina, opciones.logotipo, opciones.pueblo_bonito, opciones.incluir_departamentos))
      paginas.push(this.NominasNominaExportarBancosResumen.get(idProyecto, idNomina, opciones.logotipo, opciones.pueblo_bonito))
    }

    return this.$q.all(paginas)
      .then((response) => response.reduce((paginas, data) => paginas.concat(data), []))
      .then((paginas) => this.$export.excel2(opciones.name, paginas))
  }
}

module.service('NominasNominaExportar', NominasNominaExportarService)



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Exportar.js